import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/new-home'
import About from '@/pages/About'
import Solution from '@/pages/Solution'
import Product from '@/pages/Product'
import Contact from '@/pages/ContactUs'
import Category from '@/pages/JobCategory'
import Blog from '@/pages/BlogHome'
import BlogDetails from '@/pages/BlogDetails'
import JobSearch from '@/pages/JobSearch'
import JobSingle from '@/pages/JobSingle'
import PricingPlan from '@/pages/PricingPlan'
import Elements from '@/pages/Elements'
import Detail from '@/pages/detail'
import Service from "@/pages/Service";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/solution',
      name: 'solution',
      component: Solution
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/category',
      name: 'category',
      component: Category
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blogDetails',
      name: 'blogDetails',
      component: BlogDetails
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/jobSearch',
      name: 'jobSearch',
      component: JobSearch
    },
    {
      path: '/jobSingle',
      name: 'jobSingle',
      component: JobSingle
    },
    {
      path: '/pricingPlan',
      name: 'pricingPlan',
      component: PricingPlan
    },
    {
      path: '/elements',
      name: 'elements',
      component: Elements
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js